// extracted by mini-css-extract-plugin
module.exports = {"link":"_1ehDF0"};